import { render } from "./StatusBar.vue?vue&type=template&id=7694164c"
import script from "./StatusBar.vue?vue&type=script&lang=js"
export * from "./StatusBar.vue?vue&type=script&lang=js"
script.render = render

export default script